import React from 'react'
import styled from 'styled-components'

const Button = styled.div`
  a {
    display: block;
    background-color: #2cabe2;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#56ccf2),
      to(#2cabe2)
    );
    background-image: -webkit-linear-gradient(top, #56ccf2, #2cabe2);
    background-image: -moz-linear-gradient(top, #56ccf2, #2cabe2);
    background-image: -ms-linear-gradient(top, #56ccf2, #2cabe2);
    background-image: -o-linear-gradient(top, #56ccf2, #2cabe2);
    margin: 36px;
    font-weight: 900;
    width: 90px;
    height: 90px;
    position: relative;
    text-align: center;
    line-height: 90px;
    border-radius: 50%;
    box-shadow: 0px 3px 8px #aaa, inset 0px 2px 3px #fff;
    cursor: pointer;
    color: white;

    &:hover {
      text-decoration: none;
      color: #555;
      background: #f5f5f5;
      cursor: pointer;
    }
  }
`
const openBotAndTransferToModule = moduleName => {
  window.postMessage({ type: 'dbOpenBot', module: `${moduleName}` }, '*')
}

const HelpButton = ({ moduleName }) => {
  return (
    <Button>
      <a onClick={() => openBotAndTransferToModule(moduleName)}> Bot Help</a>
    </Button>
  )
}

export default HelpButton



// WEBPACK FOOTER //
// ./src/components/HelpButton/index.js